import { render, staticRenderFns } from "./BottomLeftChart1.vue?vue&type=template&id=39a0db5e"
import script from "./BottomLeftChart1.vue?vue&type=script&lang=js"
export * from "./BottomLeftChart1.vue?vue&type=script&lang=js"
import style0 from "./BottomLeftChart1.vue?vue&type=style&index=0&id=39a0db5e&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports